// Both the saved My Jobs response and Seeky's filter_update use the API format.
// Return a complete replacement so omitted keys clear previous dashboard filters.
export const mapApiFilterToSelectedFilters = (apiFilter = {}, query = '') => {
  const datePostedLabels = {
    past_24_hours: 'Past 24 hours',
    past_3_days: 'Past 3 days',
    past_week: 'Past 7 days',
    past_month: 'Past 30 days',
  };
  const asArray = value => Array.isArray(value) ? value : [];
  const originalCities = asArray(apiFilter?.location?.cities);
  const normalizeWorkModel = value => typeof value === 'string'
    ? value.trim().toLowerCase().replace(/[\s_-]/g, '') : '';
  const cities = originalCities.filter(city => !['remote', 'onsite'].includes(normalizeWorkModel(city)));
  const workModel = [
    originalCities.some(city => normalizeWorkModel(city) === 'remote') && 'Remote',
    originalCities.some(city => normalizeWorkModel(city) === 'onsite') && 'On-Site',
  ].filter(Boolean);
  const rawRadius = apiFilter?.location?.radius;
  const radius = rawRadius === undefined || rawRadius === null || rawRadius === '' ? undefined : Number(rawRadius);
  const hasRadius = Number.isFinite(radius) && radius > 0;
  const states = asArray(apiFilter?.location?.states);

  return {
    jobType: asArray(apiFilter?.jobTypes),
    location: {
      withinUS: cities.length === 0 && states.length === 0,
      cityState: cities,
      cities,
      radiusTouched: hasRadius,
      radius: hasRadius ? radius : 100,
    },
    datePosted: datePostedLabels[apiFilter?.datePosted] ? [datePostedLabels[apiFilter.datePosted]] : [],
    jobTitles: asArray(apiFilter?.jobTitle),
    companyName: apiFilter?.companyName || apiFilter?.company_name || apiFilter?.company || '',
    experienceLevels: asArray(apiFilter?.experienceLevels),
    workModel,
    workAuthorization: apiFilter?.workAuthorization === true || apiFilter?.workAuthorization === 'true',
    salaryRanges: apiFilter?.compensation?.minimumAnnualSalary ? [String(apiFilter.compensation.minimumAnnualSalary)] : [],
    selectedCity: cities,
    selectedState: states,
    _query: query || apiFilter?._query || '',
  };
};
